export const FACEBOOK_URL = 'https://www.facebook.com/Energy5EnergyHub/';
export const INSTAGRAM_URL = 'https://www.instagram.com/energy5_energyhub/';
export const LINKEDIN_URL = 'https://www.linkedin.com/showcase/energy5energy-hub';
export const TWITTER_URL = 'https://twitter.com/Energy517';
export const YOUTUBE_URL = 'https://www.youtube.com/@energy5energyHub';
